import { render, staticRenderFns } from "./edit-color.vue?vue&type=template&id=790d9dd0&scoped=true&"
import script from "./edit-color.vue?vue&type=script&lang=ts&"
export * from "./edit-color.vue?vue&type=script&lang=ts&"
import style0 from "./edit-color.vue?vue&type=style&index=0&id=790d9dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d9dd0",
  null
  
)

export default component.exports